import './QR.css';
import SwitchNavigation from '../translations/SwitchNavigation';

export const QR = () => {
  return (
    <div className="centered">
      <SwitchNavigation />
      <div className="qr">
        <img
          src="https://api.qrserver.com/v1/create-qr-code/?size=600x600&data=https://romashov.tech"
          className="image"
          alt="QR-link to https://romashov.tech"
        />
      </div>
    </div>
  );
};
